/** Пустое ли тело новости после удаления HTML (для валидации формы). */
export function isNewsHtmlBodyEmpty(html) {
  if (html == null || !String(html).trim()) return true;
  if (typeof document === 'undefined') {
    return !String(html).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  }
  const d = document.createElement('div');
  d.innerHTML = html;
  const t = (d.textContent || '').replace(/\u00a0/g, ' ').trim();
  return !t;
}
